/* -----------------UI--------------- */
import {
	Image,
	type ImageSourcePropType,
	Platform,
	Pressable,
} from "react-native";
import { useTheme } from "react-native-paper";

import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import { isSafeUrl } from "@memorang/helpers/common";
/* -----------------Child components--------------- */
import Box from "@memorang/ui/components/Box";

const AppStoreDownloadBadge = ({
	src,
	href,
}: {
	src: ImageSourcePropType;
	href: string;
}) => {
	const { explicitCallTrackCustomEvent } = useAnalytics();

	const handlePress = () => {
		explicitCallTrackCustomEvent({
			eventName: events.appLinkClicked,
			app_link: href,
			platform: Platform.OS,
		});
		if (!isSafeUrl(href, { allowedSchemes: ["https"] })) {
			return;
		}
		window.open(href, "_blank", "noopener,noreferrer");
	};

	return (
		<Pressable onPress={handlePress}>
			<Image
				source={src}
				style={{
					width: 121,
					height: 36,
					resizeMode: "contain",
				}}
			/>
		</Pressable>
	);
};

type Badge = {
	light: ImageSourcePropType;
	dark: ImageSourcePropType;
};

type Props = {
	ios: {
		badge: Badge;
		href?: string;
	};
	android: {
		badge: Badge;
		href?: string;
	};
};

const StoresDownloadBadge = ({ ios, android }: Props) => {
	const theme = useTheme();
	const platforms = [
		{
			platform: "ios",
			...ios,
		},
		{
			platform: "android",
			...android,
		},
	];

	const hasNoLinks = !(ios.href || android.href);

	if (hasNoLinks) {
		return null;
	}

	return (
		<Box flexDirection="row" alignItems="center" gap={4}>
			{platforms.map(({ platform, badge, href }) =>
				href ? (
					<AppStoreDownloadBadge
						key={platform}
						src={theme.dark ? badge.dark : badge.light}
						href={href}
					/>
				) : null,
			)}
		</Box>
	);
};

export default StoresDownloadBadge;
